export default __webpack_public_path__ + "static/montserrat-v14-latin-300-ad9119d587ac58273836129223be7018.ttf";